<div class="mat-typography">
  <h1 *ngIf="data.title" mat-dialog-title>{{ data.title }}</h1>
  <div mat-dialog-content>
    <p>{{ data.content }}</p>
    <mat-form-field *ngIf="data.showInput">
      <mat-label i18n>{{ data.inputPlaceholder }}</mat-label>
      <input matInput #test (focus)="test.select()" [(ngModel)]="data.input" />
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button i18n *ngIf="data.showCancel" mat-button [mat-dialog-close]="false">
      Cancel
    </button>
    <button i18n mat-button [mat-dialog-close]="data.input">OK</button>
    <button
      i18n
      color="warn"
      *ngIf="data.showDelete"
      mat-button
      [mat-dialog-close]="'delete'"
    >
      Delete
    </button>
  </div>
</div>
